import React, { FC } from "react";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Radio from "@material-ui/core/Radio";

const useStyles = makeStyles({
  root: {
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  icon: {
    borderRadius: "50%",
    width: 16,
    height: 16,
    boxShadow: "inset 0 0 0 1px #a1a4ac, inset 0 -1px 0 #a1a4ac",
    backgroundColor: "#fff",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    "$root.Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: "#fff",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background: "rgba(206,217,224,.5)",
    },
  },
  checkedIcon: {
    boxShadow: "unset",
    backgroundColor: "#2f80ed",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 16,
      height: 16,
      backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#2f80ed",
    },
  },
  label: {
    fontSize: 14,
    fontWeight: "normal",
    userSelect: "none",
    cursor: "pointer",
    color: "#a1a4ac",

    "& .MuiIconButton-root": {
      padding: "unset",
      paddingRight: 8,
      paddingBottom: 4,
    },
  },
  checked: {
    color: "#000",
  },
});

const WeduRadio: FC<any> = (props) => {
  const classes = useStyles();

  const {
    input: { checked, value, name, onChange, ...restInput },
    meta,
    label,
    ...rest
  } = props;

  return (
    <label className={clsx(classes.label, checked && classes.checked)}>
      <Radio
        name={name}
        inputProps={restInput}
        onChange={onChange}
        checked={checked}
        value={value}
        className={classes.root}
        disableRipple
        color="default"
        checkedIcon={
          <span className={clsx(classes.icon, classes.checkedIcon)} />
        }
        icon={<span className={classes.icon} />}
        {...rest}
      />
      {label}
    </label>
  );
};

export default WeduRadio;
